/* eslint-disable no-param-reassign, camelcase */
import { chain, result } from 'lodash';
import moment from 'moment';
import {
  createCrudActions,
  createCrudActionTypes,
  createCrudMutation,
  createCrudState
} from 'vuex-module-generator';

import i18n, { getDefaultMessages } from '@/i18n';
import PeriodState from '../executive-view/components/PeriodState';

import {
  fetchProjects, fetchProject, fetchProjectFilters, fetchProjectTranslations
} from './api';
// eslint-disable-next-line import/no-cycle, import/order
import store from '@/store';

export const projectTypes = {
  ...createCrudActionTypes('PROJECTS')
};

export const projectGetters = {
  scoreTemplates: state => chain(state).result('active.data.score_templates', []).sortBy('position').value(),
  allow_sku_validation: state => result(state, 'active.data.settings.allow_sku_validation'),
  allow_coverage_dashboard: state => result(state, 'active.data.settings.coverage_dashboard.enabled'),
  allow_sku_validation_editing: state => result(state, 'active.data.settings.allow_sku_validation_editing'),
  allow_imageset_objection: state => result(state, 'active.data.settings.allow_imageset_objection'),
  allow_sku_validation_approval: state => result(state, 'active.data.settings.allow_sku_validation_approval')
};

export const Projectstate = () => ({
  list: createCrudState().list,
  active: createCrudState().active
});

export const mutations = {
  ...createCrudMutation(projectTypes)
};

export const actions = createCrudActions(projectTypes);

export default {
  state: Projectstate,
  getters: projectGetters,
  mutations,
  actions: {
    cleanActiveProject({ commit }) {
      commit(actions.clean.active());
    },
    async fetchProjects({ commit }, { pagination } = {}) {
      commit(actions.index.request(pagination));
      try {
        const res = await fetchProjects(pagination);
        commit(actions.index.success(res.data));

        return Promise.resolve(res);
      } catch (error) {
        commit(actions.index.failure(error));

        return Promise.reject(error);
      }
    },
    async fetchProject({ commit }, id) {
      commit(actions.show.request(id));
      try {
        const res = await fetchProject(id);

        commit(actions.show.success(res.data));

        PeriodState.initPeriodState(); // Initialze period state for global filtering

        let globalStart = moment().subtract(1, 'week').format('YYYY-MM-DD');
        let globalEnd = moment().format('YYYY-MM-DD');

        const { searchParams } = new URL(window.location.href);
        const start = searchParams.get('start');
        const end = searchParams.get('end');

        if (start && end) {
          globalStart = start;
          globalEnd = end;
        } else {
          const { start_time, end_time } = res.data.data;

          if (start_time) {
            globalStart = start_time;
          }
          if (end_time) {
            globalEnd = end_time;
          }
        }

        const filters = chain(res)
          .result('data.data.filters', [])
          .value();

        const isCustomProjectHasFilter = res.data.data.settings.filter_tags_via_api && !store.state.Account.active.data.developer;

        const globalUtcStart = moment(globalStart).format('YYYY-MM-DD');
        const globalUtcEnd = moment(globalEnd).format('YYYY-MM-DD');

        commit('setGlobalFilterStartDate', globalUtcStart, { root: true });
        commit('setGlobalFilterEndDate', globalUtcEnd, { root: true });
        commit('addGlobalFilters', filters, { root: true });
        commit('addProjectCustomStatus', isCustomProjectHasFilter, { root: true });

        // Merge locales with project's locales
        const defaultMessages = getDefaultMessages();
        const { data: translations } = await fetchProjectTranslations(id);
        const locales = Object.keys(defaultMessages);

        localStorage.setItem('translations', JSON.stringify(translations));

        locales.forEach((locale) => {
          i18n.setLocaleMessage(locale, defaultMessages[locale]);
          i18n.mergeLocaleMessage(locale, translations[locale]);
        });

        return Promise.resolve(res);
      } catch (error) {
        commit(actions.show.failure(error));

        return Promise.reject(error);
      }
    },
    async getProjectFilters({ commit }, parameters) {
      const { projectId, filterId } = parameters;
      try {
        const res = await fetchProjectFilters(projectId, filterId);
        commit(actions.index.success(res.data));

        return Promise.resolve(res);
      } catch (error) {
        commit(actions.index.failure(error));

        return Promise.reject(error);
      }
    }
  }
};
